/* Photo gallery (sections/mad-gallery.liquid), Seth 2026-10-02.
   Filters: one button per photo tag, built from the photos on the page; they act on every gallery section.
   Viewer: tap a photo to see it large; arrows, swipe, the keyboard (left, right, Esc) move through the photos that are
   showing, in page order, across both gallery sections. */
(function () {
  'use strict';
  if (window.__madGallery) return;
  window.__madGallery = true;

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mad-gl-item]')).filter(function (li) { return !li.hidden; });
  }

  /* ── filters ── */
  function initFilters() {
    var bar = document.querySelector('[data-mad-gl-filters]');
    if (!bar) return;
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-mad-gl-item]'));
    var seen = {}, tags = [];
    all.forEach(function (li) {
      var t = (li.getAttribute('data-tag') || '').trim();
      var k = t.toLowerCase();
      if (t && !seen[k]) { seen[k] = true; tags.push(t); }
    });
    if (tags.length < 2) return; /* one tag or none: a filter would not help */
    bar.querySelectorAll('[data-mad-gl-filter]:not([data-mad-gl-filter=""])').forEach(function (b) { b.remove(); });
    tags.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mad-gl__chip';
      b.setAttribute('data-mad-gl-filter', t.toLowerCase());
      b.setAttribute('aria-pressed', 'false');
      b.textContent = t;
      bar.appendChild(b);
    });
    bar.hidden = false;
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mad-gl-filter]');
      if (!b) return;
      var want = b.getAttribute('data-mad-gl-filter');
      all = Array.prototype.slice.call(document.querySelectorAll('[data-mad-gl-item]'));
      bar.querySelectorAll('[data-mad-gl-filter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      all.forEach(function (li) {
        var t = (li.getAttribute('data-tag') || '').trim().toLowerCase();
        li.hidden = !!want && t !== want;
      });
    });
  }

  /* ── viewer ── */
  var dlg, stage, capEl, countEl, list = [], at = 0, lastFocus = null;

  function img(src, alt) {
    var i = new Image();
    i.alt = alt || '';
    i.decoding = 'async';
    i.onload = function () { i.classList.add('is-loaded'); };
    i.src = src;
    return i;
  }
  function show(n) {
    if (!list.length) return;
    at = (n + list.length) % list.length;
    var li = list[at];
    var btn = li.querySelector('[data-mad-gl-open]');
    stage.innerHTML = '';
    var pair = btn.hasAttribute('data-full-2');
    stage.classList.toggle('mad-gl__stage--pair', pair);
    if (pair) {
      [['data-full', 'data-alt', 'Before'], ['data-full-2', 'data-alt-2', 'After']].forEach(function (k) {
        var f = document.createElement('figure');
        f.appendChild(img(btn.getAttribute(k[0]), btn.getAttribute(k[1])));
        var l = document.createElement('span');
        l.className = 'mad-gl__label';
        l.textContent = k[2];
        f.appendChild(l);
        stage.appendChild(f);
      });
    } else {
      stage.appendChild(img(btn.getAttribute('data-full'), btn.getAttribute('data-alt')));
    }
    var cap = li.querySelector('[data-mad-gl-cap]');
    var link = li.querySelector('[data-mad-gl-link]');
    capEl.innerHTML = '';
    if (cap) capEl.appendChild(document.createTextNode(cap.textContent));
    if (link) {
      if (cap) capEl.appendChild(document.createTextNode('  '));
      var a = document.createElement('a');
      a.href = link.getAttribute('href');
      a.textContent = link.textContent;
      a.style.color = 'inherit';
      a.style.textUnderlineOffset = '.3rem';
      capEl.appendChild(a);
    }
    countEl.textContent = (at + 1) + ' of ' + list.length;
    /* load the next one early so the arrow feels instant */
    var nx = list[(at + 1) % list.length];
    if (nx) { var nb = nx.querySelector('[data-mad-gl-open]'); if (nb) { (new Image()).src = nb.getAttribute('data-full'); } }
  }
  function open(li) {
    if (!bindDialog()) return;
    list = items();
    var n = list.indexOf(li);
    if (n < 0) return;
    lastFocus = document.activeElement;
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    show(n);
    var close = dlg.querySelector('[data-mad-gl-close]');
    if (close) close.focus();
  }
  function closeViewer() {
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
  }
  /* the dialog can be re-rendered by the theme editor, so it is found and wired on first use */
  function bindDialog() {
    var d = document.querySelector('[data-mad-gl-viewer]');
    if (!d) return false;
    if (d === dlg && d.dataset.bound) return true;
    dlg = d;
    dlg.dataset.bound = '1';
    stage = dlg.querySelector('[data-mad-gl-stage]');
    capEl = dlg.querySelector('[data-mad-gl-viewer-cap]');
    countEl = dlg.querySelector('[data-mad-gl-count]');
    dlg.querySelector('[data-mad-gl-prev]').addEventListener('click', function () { show(at - 1); });
    dlg.querySelector('[data-mad-gl-next]').addEventListener('click', function () { show(at + 1); });
    dlg.querySelector('[data-mad-gl-close]').addEventListener('click', closeViewer);
    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      stage.innerHTML = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    /* a click on the dark area around the photo closes it */
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === stage) closeViewer(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(at + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(at - 1); }
    });
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
    });
    return true;
  }
  function initViewer() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mad-gl-open]');
      if (!b) return;
      e.preventDefault();
      open(b.closest('[data-mad-gl-item]'));
    });
  }

  function init() { initFilters(); initViewer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* the theme editor re-renders sections in place: rebuild the filter buttons when it does */
  document.addEventListener('shopify:section:load', function () { initFilters(); });
})();
